import React from 'react';
import { Box, Stack, Divider, Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const billTyps = [
    { id: 0, value: '', label: '전체', color: 'default' },
    { id: 1, value: '매출', label: '매출', color: 'primary' },
    { id: 2, value: '매입', label: '매입', color: 'warning' },
]

const useYns = [
    { id: 0, value: '', label: '전체', color: 'default' },
    { id: 1, value: 'Y', label: '완료', color: 'success' },
    { id: 2, value: 'N', label: '미완료', color: 'error' },
]


const TaxbillStatusList = ({ searchBillTyp, onChangeBillTyp, searchYn, onChangeYn, searchTyp, toggleSearchTyp }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItem: 'center',
                m: 1,
            }}
        >
            <Stack
                direction="row"
                divider={<Divider orientation="vertical" flexItem />}
                spacing={2}
            >
                <Box sx={{ mx: 1 }}>
                    {billTyps && billTyps.map((st, index) => (
                        <Chip
                            sx={{ mr: 2 }}
                            key={index}
                            icon={<CircleIcon />}
                            label={st.label}
                            variant={st.value === searchBillTyp ? 'contained' : 'outlined'}
                            color={st.color}
                            onClick={() => onChangeBillTyp(st.value)}
                        />
                    ))}
                </Box>
                {/* <Box sx={{ mx: 1 }}>
                <Chip
                    icon={<CircleIcon />}
                    label="월별 조회"
                    variant={searchTyp ? 'contained' : 'outlined'}
                    color="info"
                    onClick={() => toggleSearchTyp()}
                />
            </Box> */}
                <Box sx={{ mx: 1 }}>
                    {useYns && useYns.map((st, index) => (
                        <Chip
                            sx={{ mr: 2 }}
                            key={index}
                            icon={<CircleIcon />}
                            label={st.label}
                            variant={st.value === searchYn ? 'contained' : 'outlined'}
                            color={st.color}
                            onClick={() => onChangeYn(st.value)}
                        />
                    ))}
                </Box>
            </Stack>
        </Box>
    )
}

export default TaxbillStatusList